<template>
  <div class="zjxPageFooter">
    <div class="zjxPageFooter_center">
      <div class="zjxFooter_view1">
        <span class="zjxFooter_view1_span">
          <p class="specil_foot__p">电话：{{ basicInfo.cellphone }}</p>
          <p style="min-width: 138px">邮政编码：{{ basicInfo.postCode }}</p>
        </span>
        <span class="zjxFooter_view1_span">
          <p>E-mail：{{ basicInfo.email }}</p>
          <p style="min-width: 138px">传真号码：{{ basicInfo.fax }}</p>
        </span>
        <span class="zjxFooter_view1_span">
          <p>地址：{{ basicInfo.address }}</p>
        </span>
      </div>
      <div class="zjxFooter_view2">
        <p>版权所有：{{ basicInfo.copyrightOwner }}</p>
        <p>{{ basicInfo.recordNumber }}</p>
        <p>备案编号：{{ basicInfo.icp }}</p>
      </div>
      <div class="zjxFooter_view3">
        <div class="normalBot">
          <img
            :src="basicInfo.subCode"
            style="width: 70px; height: 70px"
            alt=""
          />
          <p>会员服务订阅号</p>
        </div>
        <div class="normalBot">
          <img
            :src="basicInfo.qrCode"
            style="width: 70px; height: 70px"
            alt=""
          />
          <p>微信服务号</p>
        </div>
        <!-- <div class="zjxBottom_links">
					<el-dropdown placement="top" @command="handleCommand">
						<span class="el-dropdown-link">
							部委网站
							<i class="el-icon-arrow-down el-icon--right"></i>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item v-for="(item,index) in linkOne" :command="item.link_path" :key="index">
								{{item.link_name}}
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
				<div class="zjxBottom_links" style="margin-top: 15px;">
					<el-dropdown placement="top" @command="handleCommand">
						<span class="el-dropdown-link">
							中国行业协会网站
							<i class="el-icon-arrow-down el-icon--right"></i>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item v-for="(item,index) in linkTwo" :command="item.link_path" :key="index">
								{{item.link_name}}
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { getBasicInfo, apirequest, getNavList } from "../api/moudles/user.js";
export default {
  data() {
    return {
      basicInfo: {},
      linkOne: [],
      linkTwo: [],
    };
  },
  created() {
    this.getNavList();
  },
  methods: {
    // 下拉选择
    handleCommand(command) {
      if (command) {
        window.open(command);
      }
    },
    // 导航栏
    async getNavList() {
      this.topNav = false;
      await getNavList({
        data: {
          position: 1,
        },
        success: (res) => {
          console.log('resssss', res)
          const indexCodeList = res.data[0].children;
          indexCodeList.forEach((item) => {
            if (item.label == "基本信息") {
              this.getBasicInfo(item.key);
            }
            if (item.label == "友情链接") {
              this.apirequest(item.children[0].key);
            }
          });
        },
      });
    },
    // 获取基本信息
    async getBasicInfo(column_code) {
      await getBasicInfo({
        data: {
          column_code,
        },
        success: (res) => {
          console.log('基本信息', res)
          this.basicInfo = res.data;
        },
      });
    },
    // 友情链接
    async apirequest(column_code) {
      await apirequest({
        data: {
          column_code,
        },
        success: (res) => {
          const linkData = res.data;
          Object.keys(linkData).forEach((item) => {
            if (item == "部委网站") {
              this.linkOne = linkData[item];
            }
            if (item == "中国行业协会网站") {
              this.linkTwo = linkData[item];
            }
          });
        },
      });
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 750px) {
  .zjxPageFooter {
    width: 100%;
    min-height: 160px;
    background-color: #bc141d;
  }

  .zjxPageFooter_center {
    padding-top: 20px;
    width: 100%;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
  }

  .zjxFooter_view1_span {
    margin: 5px 0;
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .zjxFooter_view2 {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .zjxFooter_view3 {
    display: none;
  }
}

@media screen and (min-width: 750px) {
  .specil_foot__p {
    margin-right: 50px;
  }

  .zjxPageFooter {
    width: 100%;
    height: 160px;
    background-color: #bc141d;
  }

  .zjxPageFooter_center {
    padding-top: 20px;
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
  }

  .zjxFooter_view1_span {
    margin: 5px 0;
    display: flex;
    min-width: 410px;
    justify-content: space-between;
  }

  .zjxFooter_view2 {
    width: 350px;
  }

  .zjxFooter_view3 {
    width: 220px;
    height: 100px;
    display: flex;
    justify-content: space-between;
  }
}

.normalBot {
  display: flex;
  flex-flow: column;
  align-items: center;
}

.normalBot p {
  margin-top: 11.11px;
  font-family: PingFangSC-Semibold;
  font-size: 14px;
  color: #feffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 600;
}

p {
  color: #fff;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  letter-spacing: 0;
  font-weight: 400;
}

.zjxFooter_view2 > p {
  margin: 5px 0;
}

.zjxBottom_links {
  width: 190px;
  height: 30px;
  background-color: #840f15;
}

.zjxBottom_links .el-dropdown {
  color: #fff;
  width: 190px;
  text-align: center;
  line-height: 30px;
}
</style>
